import { call, put } from 'redux-saga/effects';

import { deleteSavedFilingPeriodFileSuccess } from '@actions/savedFilingPeriod';
import { deleteSavedFilingPeriodFile } from '@api/savedFilingPeriod';

export const deleteFileSaga = function* ({ payload }) {
  yield call(deleteSavedFilingPeriodFile, payload.id);

  yield put(deleteSavedFilingPeriodFileSuccess(payload));
};
